import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileQuestion, Search, Home } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { ROUTES } from '@/constants/routes';
import { useShellState } from '../context/ShellContext';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { setIsCommandPaletteOpen } = useShellState();

  return (
    <div className="flex min-h-[70vh] w-full flex-col items-center justify-center p-6 text-center">
      <div className="rounded-full bg-muted p-4 text-foreground-secondary shadow-xs">
        <FileQuestion className="h-10 w-10" />
      </div>
      <h1 className="mt-4 text-2xl font-bold tracking-tight text-foreground">404 — Page Not Found</h1>
      <p className="mt-1 max-w-md text-xs text-foreground-secondary leading-relaxed">
        The requested procurement route or document could not be located on this server.
      </p>
      <div className="mt-6 flex items-center gap-3">
        <Button variant="outline" size="sm" onClick={() => setIsCommandPaletteOpen(true)}>
          <Search className="h-4 w-4 mr-1.5" /> Search Entities (Ctrl+K)
        </Button>
        <Button size="sm" onClick={() => navigate(ROUTES.DASHBOARD)}>
          <Home className="h-4 w-4 mr-1.5" /> Return to Dashboard
        </Button>
      </div>
    </div>
  );
};
